import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import PopupLayout from "../../components/templetes/popupLayout";
import { StyledButton } from "../../components/atoms/button";
import { ValidationInput } from "../../components/atoms/validation/ValidationInput";
import { StyledButtonArea } from "../../components/molecules/buttonArea";

const ForgotPasswordPopup = ({ resetPassword, closePopup }) => {
  const { t } = useTranslation();
  const [validate, setValidate] = useState(false);
  const [userId, setUserId] = useState("");
  const [email, setEmail] = useState("");
  const [page, setPage] = useState(0);

  const onSubmit = () => {
    setValidate(true);
    if (userId === "" || email === "") return;
    resetPassword(
      {
        userId: userId,
        email: email,
      },
      () => {
        setPage(1);
      }
    );
  };

  return (
    <>
      <PopupLayout
        theme="primary"
        data-size="lg"
        title={t("resetPw.title")}
        closePopup={closePopup}
        button={
          <StyledButtonArea>
            {page === 0 && (
              <StyledButton
                type="text"
                data-bg="primary"
                size="md"
                onClick={onSubmit}
              >
                {t("resetPw.submit")}
              </StyledButton>
            )}
          </StyledButtonArea>
        }
      >
        {page === 0 && (
          <div style={{ paddingLeft: "3%", paddingRight: "3%" }}>
            <ValidationInput
              label={t("resetPw.userId")}
              type="text"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              showValidate={validate}
              invalidMsg={t("resetPw.userIdRequired")}
            />
            <ValidationInput
              label={t("resetPw.email")}
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              showValidate={validate}
              invalidMsg={t("resetPw.emailRequired")}
            />
          </div>
        )}
        {page === 1 && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              minHeight: "50px",
              textAlign: "center",
              lineHeight: "normal"
            }}
          >
            {t("resetPw.sent", { email })}
          </div>
        )}
      </PopupLayout>
    </>
  );
};

export default ForgotPasswordPopup;
